import {useTranslation} from "react-i18next";
import "./News.css"
import {Card} from "react-bootstrap";
import {DateTime} from "luxon";
import {LocalData, newsData, useData} from "../../components/hooks/recoilData";
import {useRecoilState} from "recoil";
import useAnimation from "../../utils/hooks/animate";
import {useCallback, useEffect} from "react";

export const News = () => {
    const {i18n, t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("news")});
    }, [t]);

    const [, , updateNews] = useData();
    updateNews();
    const [news,] = useRecoilState(newsData);

    const isRu: boolean = i18n.language === "ru";
    const getText = useCallback((local: LocalData) => {
        if (!local)
            return "";
        if (isRu && local.ru)
            return local.ru;
        return local.en ? local.en : local.ru;
    }, [isRu]);

    return (
        <main className="pt-2">
            <section>
                {news.map((newsE, id) => (
                    <Card key={id}>
                        {/*<Card.Header>{blog.title}</Card.Header>*/}
                        {/*<Card.Img variant="top" src="holder.js/100px180" />*/}
                        <Card.Body>
                            <Card.Title>{getText(newsE.title)}</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">{DateTime.fromMillis(newsE.date).toFormat('dd.MM.yyyy')}</Card.Subtitle>
                            <Card.Text as="div">
                                <div dangerouslySetInnerHTML={{__html: getText(newsE.description)}}/>
                            </Card.Text>
                            {/*<Card.Link href={"#/blog/" + blog.id}>Card Link</Card.Link>*/}
                        </Card.Body>
                    </Card>
                ))}
            </section>
        </main>
    );
};